import { ForecastParamCode, Forecasts } from 'pleinchamp-api-client';
import { Geopoint } from 'pleinchamp-api-client/dist/src/custom';
import { ComponentPropsWithRef, RefObject } from 'react';
import { Dayjs } from 'dayjs';

export const MOCK_STRING = 'xx';

export enum Direction {
  Left,
  Right,
}

export const WEATHER_TABLE_CELL_WIDTH = 60;

export interface WeatherTableProps extends ComponentPropsWithRef<'table'> {
  forecasts?: Forecasts;
  onLoadMore?: () => void;
  isMoreToDisplay?: boolean;
  coordinates: Geopoint;
  format15Days?: boolean;
  isPro?: boolean;
  isChartEnabled?: boolean;
  displayHHLink?: boolean;
  thirtySixHours?: boolean;
  withDays?: boolean;
  top?: number;
  onChangeIsMoreMetrics?: boolean;
}

export interface MetricsType {
  key: ForecastParamCode;
  data: (string | number)[];
}

export type WeatherTableContentProps = Omit<WeatherTableProps, 'forecasts'> & {
  dates: Dayjs[];
  format15Days?: boolean;
  isPro?: boolean;
  weatherCodes: Array<number | undefined>;
  metrics: Forecasts;
  timeframe: 'PT0S' | 'PT3H';
  isLoading?: boolean;
  onChangeIsMoreMetrics?: boolean;
};

export function filterParamsToDisplay(param: ForecastParamCode) {
  return !(
    param === ForecastParamCode.weatherCode ||
    param === ForecastParamCode.airTemperature ||
    param === ForecastParamCode.nbMetrics
  );
}

export function getScroll(ref: RefObject<HTMLDivElement>, dir: Direction) {
  if (!ref.current) {
    return undefined;
  }
  const { scrollLeft, scrollWidth, clientWidth } = ref.current;
  switch (dir) {
    case Direction.Left: {
      return scrollLeft;
    }
    case Direction.Right: {
      return scrollWidth - (scrollLeft + clientWidth);
    }
    default: {
      const testSwitch: never = dir;
      return testSwitch;
    }
  }
}
